export default "__VITE_ASSET__DrJOSXsi__"